module.exports = __webpack_public_path__ + "static/media/bg.c1759d44.jpg";